import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';
import feeCardFront from "../../assets/images/feeCard/feeCardFront.jpeg";
//import bodoniBold from "../../assets/fonts/BodoniFLF-Bold.ttf";

// Font.register({
//   family: 'BodoniFLF',
//   src: require("../../assets/fonts/BodoniFLF-Bold.ttf"),
//   //fontWeight: 'bold',
// });

// Define styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#fff",
    padding: 10,
    width: 595.3, // 210mm in points
    height: 419.5, // 148mm in points
  },
  header: {
    fontSize: 18,
    textAlign: "center",
    marginBottom: 10,
    fontWeight: "bold",
  },
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 10,
    marginBottom: 10,
  },
  imageContainer: {
    width: 595.3,
    height: 380
    //position: "relative",
  },
  image: {
    width: "100%",
    height: "100%",
  },
  textOverlay: {
    //position: "absolute",
    top: 60,
    right: 70,
    fontSize: 14,
    padding: 5,
    borderRadius: 5,
  },
  table: {
    display: 'flex',
    flexDirection: 'row',
    border: '1px solid black',
  },
  half: {
    flex: 1,
    borderRight: '1px solid black',
  },
  row: {
    flexDirection: 'row',
  },
  headerCell: {
    border: '1px solid black',
    padding: 4,
    textAlign: 'center',
    flexGrow: 1,
    height: 40,
    justifyContent: 'center',
  },
  cell: {
    border: '1px solid black',
    padding: 4,
    textAlign: 'center',
    flexGrow: 1,
    height: 50,
    justifyContent: 'center',
  },
  // Specific column widths
  colMonth: { flexBasis: '15%', fontSize: 12, flexWrap: 'wrap', whiteSpace: 'normal' },
  colDate: { flexBasis: '15%', fontSize: 12, flexWrap: 'wrap', whiteSpace: 'normal' },
  colAmount: { flexBasis: '17%', fontSize: 12, flexWrap: 'wrap', whiteSpace: 'normal' },
  colBalance: { flexBasis: '20%', fontSize: 12, flexWrap: 'wrap', whiteSpace: 'normal' },
  colReceipt: { flexBasis: '20%', fontSize: 12, flexWrap: 'wrap', whiteSpace: 'normal' },
  colSign: { flexBasis: '13%', fontSize: 12, flexWrap: 'wrap', whiteSpace: 'normal' },
});

// Column headers
const headers = ['Month', 'Date', 'Amount', 'Balance', 'Receipt No.', 'Sign.'];


const FeeCardPDF = ({ systemData, studentData, sessionData, monthlyFees, enrollmentData }) => {

const showValue = (val) => val ?? " ";

  return (
    <Document>
      <Page size="A4" style={styles.page}>

        <View style={styles.container}>
          {/* First Image with Overlay Text */}
          <View style={styles.imageContainer}>
            <Image style={styles.image} src={feeCardFront} />

            <View style={{
              position: "absolute",
              top: 50,
              left: 310,
              width: 250,
              padding: 10,
              alignItems: "center"  // centers content horizontally
            }}>
              <Text style={{
                fontSize: 18, color: "green", textAlign: "center", marginBottom: 5,
                //fontFamily: 'BodoniFLF',
                //fontWeight: 'bold'
              }}>
                {systemData.school_name}
              </Text>


              <Text style={{ fontSize: 13, color: "red", textAlign: "center", marginBottom: 5 }}>
                {systemData.school_type}
              </Text>
              <Text style={{ fontSize: 11, color: "purple", textAlign: "center" }}>
                {systemData.address}
              </Text>
              <Text style={{ fontSize: 11, color: "purple", textAlign: "center" }}>
                {systemData.school_phn}
              </Text>
            </View>

            <View style={{
              position: "absolute",
              top: 160,
              left: 330,
              width: 230,
              padding: 10,
              fontSize: 11
            }}>
              {[
                { label: "Adm. No.", value: studentData.admit_no },
                { label: "Name", value: studentData.stud_name },
                { label: "Class", value: enrollmentData.enrollmentData[0]?.course_name },
                { label: "Father", value: studentData.f_name },
                 { label: "Mob.", value: showValue(`${studentData?.f_mob ?? ""}${studentData?.m_mob ? ", " + studentData.m_mob : ""}`) },
  { label: "Address", value: showValue(`${studentData?.sadd1 ?? ""} ${studentData?.sadd2 ?? ""}`.trim()) }
              ].map((item, index) => (
                <View key={index} style={{ flexDirection: "row", marginBottom: 5 }}>
                  <Text style={{ width: 70, fontWeight: "bold" }}>{item.label}</Text>
                  <Text style={{ flex: 1 }}>: {item.value ?? ""} </Text>
                </View>
              ))}
            </View>
            <Text style={{ position: "absolute", top: 310, left: 397, fontSize: 11 }}>{sessionData.session_year}</Text>          </View>   
        </View>
      </Page>

      <Page size="A4" style={styles.page}>
        <View style={styles.table}>
          {/* Left Half */}
          <View style={styles.half}>
            {/* Headers */}
            <View style={styles.row}>
              <Text style={[styles.headerCell, styles.colMonth]}>Month</Text>
              <Text style={[styles.headerCell, styles.colDate]}>Date</Text>
              <Text style={[styles.headerCell, styles.colAmount]}>Amount</Text>
              <Text style={[styles.headerCell, styles.colBalance]}>Balance</Text>
              <Text style={[styles.headerCell, styles.colReceipt]}>Receipt No.</Text>
              <Text style={[styles.headerCell, styles.colSign]}>Sign.</Text>
            </View>

            {/* Hardcoded rows - Left Side */}
            <View style={styles.row}>
              <Text style={[styles.cell, styles.colMonth]}>April &nbsp;{enrollmentData.enrollmentData[0]?.month_tot_1}</Text>
              <Text style={[styles.cell, styles.colDate]}></Text>
              <Text style={[styles.cell, styles.colAmount]}></Text>
              <Text style={[styles.cell, styles.colBalance]}></Text>
              <Text style={[styles.cell, styles.colReceipt]}></Text>
              <Text style={[styles.cell, styles.colSign]}></Text>
            </View>
            <View style={styles.row}>
              <Text style={[styles.cell, styles.colMonth]}>May &nbsp;{enrollmentData.enrollmentData[0]?.month_tot_2}</Text>
              <Text style={[styles.cell, styles.colDate]}></Text>
              <Text style={[styles.cell, styles.colAmount]}></Text>
              <Text style={[styles.cell, styles.colBalance]}></Text>
              <Text style={[styles.cell, styles.colReceipt]}></Text>
              <Text style={[styles.cell, styles.colSign]}></Text>
            </View>
            <View style={styles.row}>
              <Text style={[styles.cell, styles.colMonth]}>June &nbsp;{enrollmentData.enrollmentData[0]?.month_tot_3}</Text>
              <Text style={[styles.cell, styles.colDate]}></Text>
              <Text style={[styles.cell, styles.colAmount]}></Text>
              <Text style={[styles.cell, styles.colBalance]}></Text>
              <Text style={[styles.cell, styles.colReceipt]}></Text>
              <Text style={[styles.cell, styles.colSign]}></Text>
            </View>
            <View style={styles.row}>
              <Text style={[styles.cell, styles.colMonth]}>July &nbsp;{enrollmentData.enrollmentData[0]?.month_tot_4}</Text>
              <Text style={[styles.cell, styles.colDate]}></Text>
              <Text style={[styles.cell, styles.colAmount]}></Text>
              <Text style={[styles.cell, styles.colBalance]}></Text>
              <Text style={[styles.cell, styles.colReceipt]}></Text>
              <Text style={[styles.cell, styles.colSign]}></Text>
            </View>
            <View style={styles.row}>
              <Text style={[styles.cell, styles.colMonth]}>Aug &nbsp;{enrollmentData.enrollmentData[0]?.month_tot_5}</Text>
              <Text style={[styles.cell, styles.colDate]}></Text>
              <Text style={[styles.cell, styles.colAmount]}></Text>
              <Text style={[styles.cell, styles.colBalance]}></Text>
              <Text style={[styles.cell, styles.colReceipt]}></Text>
              <Text style={[styles.cell, styles.colSign]}></Text>
            </View>
            <View style={styles.row}>
              <Text style={[styles.cell, styles.colMonth]}>Sept. &nbsp;{enrollmentData.enrollmentData[0]?.month_tot_6}</Text>
              <Text style={[styles.cell, styles.colDate]}></Text>
              <Text style={[styles.cell, styles.colAmount]}></Text>
              <Text style={[styles.cell, styles.colBalance]}></Text>
              <Text style={[styles.cell, styles.colReceipt]}></Text>
              <Text style={[styles.cell, styles.colSign]}></Text>
            </View>
          </View>

          {/* Right Half */}
          <View style={styles.half}>
            {/* Headers */}
            <View style={styles.row}>
              <Text style={[styles.headerCell, styles.colMonth]}>Month</Text>
              <Text style={[styles.headerCell, styles.colDate]}>Date</Text>
              <Text style={[styles.headerCell, styles.colAmount]}>Amount</Text>
              <Text style={[styles.headerCell, styles.colBalance]}>Balance</Text>
              <Text style={[styles.headerCell, styles.colReceipt]}>Receipt No.</Text>
              <Text style={[styles.headerCell, styles.colSign]}>Sign.</Text>
            </View>

            {/* Hardcoded rows - Right Side */}
            <View style={styles.row}>
              <Text style={[styles.cell, styles.colMonth]}>Oct. &nbsp;{enrollmentData.enrollmentData[0]?.month_tot_7}</Text>
              <Text style={[styles.cell, styles.colDate]}></Text>
              <Text style={[styles.cell, styles.colAmount]}></Text>
              <Text style={[styles.cell, styles.colBalance]}></Text>
              <Text style={[styles.cell, styles.colReceipt]}></Text>
              <Text style={[styles.cell, styles.colSign]}></Text>
            </View>
            <View style={styles.row}>
              <Text style={[styles.cell, styles.colMonth]}>Nov. &nbsp;{enrollmentData.enrollmentData[0]?.month_tot_8}</Text>
              <Text style={[styles.cell, styles.colDate]}></Text>
              <Text style={[styles.cell, styles.colAmount]}></Text>
              <Text style={[styles.cell, styles.colBalance]}></Text>
              <Text style={[styles.cell, styles.colReceipt]}></Text>
              <Text style={[styles.cell, styles.colSign]}></Text>
            </View>
            <View style={styles.row}>
              <Text style={[styles.cell, styles.colMonth]}>Dec. &nbsp;{enrollmentData.enrollmentData[0]?.month_tot_9}</Text>
              <Text style={[styles.cell, styles.colDate]}></Text>
              <Text style={[styles.cell, styles.colAmount]}></Text>
              <Text style={[styles.cell, styles.colBalance]}></Text>
              <Text style={[styles.cell, styles.colReceipt]}></Text>
              <Text style={[styles.cell, styles.colSign]}></Text>
            </View>
            <View style={styles.row}>
              <Text style={[styles.cell, styles.colMonth]}>Jan. &nbsp;{enrollmentData.enrollmentData[0]?.month_tot_10}</Text>
              <Text style={[styles.cell, styles.colDate]}></Text>
              <Text style={[styles.cell, styles.colAmount]}></Text>
              <Text style={[styles.cell, styles.colBalance]}></Text>
              <Text style={[styles.cell, styles.colReceipt]}></Text>
              <Text style={[styles.cell, styles.colSign]}></Text>
            </View>
            <View style={styles.row}>
              <Text style={[styles.cell, styles.colMonth]}>Feb. &nbsp;{enrollmentData.enrollmentData[0]?.month_tot_11}</Text>
              <Text style={[styles.cell, styles.colDate]}></Text>
              <Text style={[styles.cell, styles.colAmount]}></Text>
              <Text style={[styles.cell, styles.colBalance]}></Text>
              <Text style={[styles.cell, styles.colReceipt]}></Text>
              <Text style={[styles.cell, styles.colSign]}></Text>
            </View>
            <View style={styles.row}>
              <Text style={[styles.cell, styles.colMonth]}>Mar. &nbsp;{enrollmentData.enrollmentData[0]?.month_tot_12}</Text>
              <Text style={[styles.cell, styles.colDate]}></Text>
              <Text style={[styles.cell, styles.colAmount]}></Text>
              <Text style={[styles.cell, styles.colBalance]}></Text>
              <Text style={[styles.cell, styles.colReceipt]}></Text>
              <Text style={[styles.cell, styles.colSign]}></Text>
            </View>
          </View>
        </View>
        {/* <View style={styles.container}>
          <View style={styles.imageContainer}>
            <Image style={styles.image} src={feeCardBack} />

            <View style={{
              position: "absolute",
              top: 14,
              left: 30,
              right: 30,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              paddingHorizontal: 10,
              paddingVertical: 5
            }}>
              <Text style={{ fontSize: 14 }}>SESSION: {sessionData.session_year}</Text>
              <Text style={{ fontSize: 14 }}>Adm No.: {studentData.admit_no}</Text>
              <Text style={{ fontSize: 14 }}>Name: {studentData.stud_name}</Text>
            </View>

            <Text style={{
  position: 'absolute',
  top: 80,  // Adjust Y properly to match your Month row
  left: 12,  // Adjust X to align with first "Month" box
  width: 60,
  height: 30,
  fontSize: 12,
  textAlign: 'center',
  color: 'black',
}}>
  APRIL

  1200
</Text>

          </View>
        </View> */}
      </Page>
    </Document>
  )
};

export default FeeCardPDF;
